export class ListingRequest {
	constructor(filters, query, fetchAll, nextPage) {
		this.filters = filters
		this.query = query
		this.all = fetchAll
		this.page = nextPage
	}
}
